<template>
	<!-- 会员记录 -->
	<div class="wid-12" style="width: 100%;">
		<div :class="isShow ? 'box-shadow pad-1':'box-shadow'" class="mb-16" v-for="(item,index) in recordList"
			:key="index">
			<div class="mb-16">
				<div v-show="item.refundAuditStatus !== null || item.refundStatus==3">
					<div class="flex-1 jus-bet shenhe"
						:class="item.refundAuditStatus==1000 ?'shen-bg1':item.refundAuditStatus==2000 || item.refundStatus==3?'shen-bg2':'shen-bg'">
						<div>
							<p
								:class="item.refundAuditStatus==1000?'sh-p1':item.refundAuditStatus==2000 || item.refundStatus==3?'sh-p2':'sh-p'">
								退款申请:
								<span
									:class="item.refundAuditStatus==1000?'sh-span1':item.refundAuditStatus==2000 || item.refundStatus==3?'sh-span2':'sh-span'">
									{{item.refundAuditStatus==1000?'已申请,审核中':item.refundAuditStatus==2000?'申请通过':item.refundAuditStatus==3000?'申请驳回'+','+item.refundReason:''}}{{item.refundStatus==1?',退款中':item.refundStatus==2?',退款成功':''}}{{item.refundStatus==3?'已退款':''}}
								</span>
								<span class="sh-span" v-if="item.refundAuditStatus==3000">请重新申请</span>
							</p>
						</div>
						<div v-show="item.refundStatus==2">
							<p class="sh-p2">退款时间:<span class="sh-span2">{{utils.getNowTime(item.refundTime)}}</span>
							</p>
						</div>
					</div>
				</div>
				<div :class="!isShow ? 'pad-2':''">
					<div class="flex-1 jus-bet vipp border-b">
						<div>
							<p>会员名称</p>
							<p>{{item.memberName}}</p>
						</div>
						<div>
							<p>观看课程权限</p>
							<p>{{item.limitsStatus == true?'已开通':'未开通'}}</p>
						</div>
						<div>
							<p>已解锁名额</p>
							<p>{{item.lockNum==null?'0':item.lockNum}}位</p>
						</div>
						<div>
							<p>剩余解锁名额</p>
							<p>{{item.endLockNum==null?'0':item.endLockNum}}位</p>
						</div>
						<div></div>
					</div>
					<div class="flex-1 jus-bet " :class="item.refundable == true?'border-b':''"
						style="padding: 36px 0;flex-wrap: wrap;">
						<div class="flex-1 font1" v-if="item.no">
							订单编号:
							<p>{{item.no}}</p>
						</div>
						<div class="flex-1 font1" v-if="item.no">
							支付金额:
							<p>{{item.payPrice}}</p>
						</div>
						<div class="flex-1 font1" v-if="item.no">
							购买时间:
							<p>{{utils.getNowTime(item.payTime)}}</p>
						</div>
						<div class="flex-1 font1" v-if="!item.no">
							开通时间:
							<p>{{utils.getNowTime(item.startTime)}}</p>
						</div>
						<div class="flex-1 font1">
							有效时长:
							<p>{{item.term}}个月</p>
						</div>
						<div></div>
					</div>
				</div>

			</div>
			<div class="flex-1 jus-bet" :class="!isShow ? 'pad-3':''"
				v-show="item.refundable == true && item.refundAuditStatus !== 1000 && item.refundAuditStatus !== 2000">
				<div></div>
				<el-button type="primary" @click="apply(item.id)">申请退款</el-button>
			</div>

		</div>
		<el-pagination class="pages" v-show="pageInline.tableTotal>0" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" :page-sizes="pageGroup.sizes" :page-size="pageGroup.size"
			layout="total, sizes, prev, pager, next, jumper" :total="pageInline.tableTotal">
		</el-pagination>
		<!-- 申请退款提示 -->
		<el-dialog title="" :visible.sync="dialogPly" width="25%">
			<div class="flex-1 jus-bet">
				<div></div>
				<div>
					<div class="flex-1 jus-bet">
						<div></div>
						<div class="flex-1 tan-1">
							<img src="../../../assets/myself/tixing.png" alt="">
							<p>确定提交退款申请吗?</p>
						</div>
						<div></div>
					</div>
					<div class="tishis flex-1">
						<p @click="handleClose">取消</p>
						<p @click="submit">确定</p>
					</div>
				</div>
				<div></div>
			</div>

		</el-dialog>
	</div>
</template>

<script>
	import {
		getRecord,
		getWildRecord,
		getRefund
	} from '@/api/personal/api.js';
	export default {
		components: {},
		data() {
			return {
				dialogPly: false,
				isShow: false,
				recordList: [],
				page: 1,
				limit: this.pageGroup.size,
				//分页对象
				pageInline: {
					tableSizes: this.pageGroup.sizes, //显示条数分组
					tableTotal: 10, // 默认数据总数
				},
				orderId: ''
			}

		},
		mounted() {
			this.getMyRecord();
		},
		methods: {
			getMyRecord() {
				let params = {
					pageNo: this.page,
					pageSize: this.pageGroup.size,
				}
				getWildRecord(params).then(res => {
					this.recordList = res.data.list;
					this.pageInline.tableTotal = res.data.total
				})
			},
			//页容量改变时会触发
			handleSizeChange(size) {
				this.limit = size;
				this.getMyRecord();
			},
			//当前页改变时会触发
			handleCurrentChange(currentPage) {
				this.page = currentPage;
				this.getMyRecord();
			},
			record() {
				this.$router.push("/personal/record/index");
			},
			apply(id) {
				this.dialogPly = true;
				this.orderId = id
			},
			handleClose() {
				this.dialogPly = false
			},
			submit() {
				let params = {
					orderId: this.orderId
				}
				console.log(params, 'params')
				getRefund(params).then(res => {
					console.log(res, '===res')
					this.dialogPly = false;
					this.$message.success('申请成功');
					this.getMyRecord();
				})
				// this.isShow = true
			}
		}
	}
</script>

<style>

</style>
<style scoped>
	.box-shadow {
		box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-1 {
		padding: 32px 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.mb-24 {
		margin-bottom: 24px;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.vipp div p:first-child,
	.tishi {
		font-family: font3;
		color: #666666;
		font-size: 14px;
		margin-bottom: 8px;
	}

	.vipp div p:last-child,
	.hui {
		font-family: font5;
		color: #222222;
		font-size: 16px;
	}

	.unPhoto {
		/* width: 100%;height: auto; */
	}

	.tishi {
		color: #FF4E33 !important;
	}

	.border-b {
		border-bottom: 1px solid #EFEFEF;
		padding-bottom: 16px;
	}

	.font1 {
		color: #999999;
		font-size: 14px;
		font-family: font3;
		white-space: nowrap;
	}

	.font1 p {
		color: #222222;
		padding-left: 16px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		/* width: 50px; */
	}

	.el-button--primary {
		background-color: #3377FF;
		color: #ffffff;
		border-radius: 35px 35px 35px 35px;
		/* width: 10%; */
	}

	.el-button--primary span {
		font-size: 16px;
		font-family: font3;
	}

	.tan-1 {
		margin-bottom: 32px;
	}

	.tan-1 img {
		width: 22px;
		height: 22px;
	}

	.tan-1 p {
		color: #2D2D2E;
		font-weight: font5;
		font-size: 18px;
		padding-left: 10px;
	}

	/deep/.el-dialog {
		border-radius: 8px;
	}

	/deep/.el-dialog__header {
		padding: 0;
	}

	/deep/.el-dialog__body {
		padding: 20px;
	}

	/deep/.el-icon-close:before {
		display: none;
	}

	.tishis p {
		font-size: 16px;
		font-family: font5;
		padding: 12px 44px;
		border-radius: 4px 4px 4px 4px;
	}

	.tishis p:first-child {
		color: #666666;
		background-color: #EFEFEF;
		margin-right: 2.5rem;
	}

	.tishis p:last-child {
		color: #FFFFFF;
		background-color: #3377FF;
	}

	.shenhe {
		padding: 6px 16px;
		font-size: 14px;
		border-radius: 8px 8px 0 0;
	}

	.shenhe span {
		font-family: font4;
		padding-left: 1rem;
	}

	.shenhe .sh-p {
		font-family: font3;
	}

	.shen-bg {
		background-color: #FFF0F0;
	}

	.sh-span {
		color: #FF534D;
	}

	.sh-p {
		color: #FF534D;
	}

	.shen-bg1 {
		background-color: #FFF6F0;
	}

	.sh-span1 {
		color: #FBB54C;
	}

	.sh-p1 {
		color: #FBB54C;
	}

	.shen-bg2 {
		background-color: #EBFAEF;
	}

	.sh-span2 {
		color: #3ECC64;
	}

	.sh-p2 {
		color: #3ECC64;
	}




	.pad-2 {
		padding: 1rem;
	}

	.pad-3 {
		padding: 0 16px 16px 0;
	}
</style>